/**
 * Apollo operation context flag. Operations that handle `UNAUTHENTICATED` themselves
 * (token refresh, logout) set it so the global error link does not end the session or
 * toast "session expired" for them; this also keeps a failed refresh from looping.
 */
export const SKIP_SESSION_EXPIRED = 'skipSessionExpired';

export const SKIP_SESSION_EXPIRED_CONTEXT: Readonly<Record<string, unknown>> = {
  [SKIP_SESSION_EXPIRED]: true,
};
